import scrollDir from 'scrolldir';
document.addEventListener("DOMContentLoaded", function() {
    scrollDir({ thresholdPixels: 64 });
});
